import script from "./EmptyChat.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyChat.vue?vue&type=script&setup=true&lang=js"

import "./EmptyChat.vue?vue&type=style&index=0&id=f20e452c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f20e452c"]])

export default __exports__